import { render, staticRenderFns } from "./newPostComponent.vue?vue&type=template&id=b9a2c230&scoped=true"
import script from "./newPostComponent.vue?vue&type=script&lang=js"
export * from "./newPostComponent.vue?vue&type=script&lang=js"
import style0 from "./newPostComponent.vue?vue&type=style&index=0&id=b9a2c230&prod&scoped=true&lang=css"
import style1 from "./newPostComponent.vue?vue&type=style&index=1&id=b9a2c230&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a2c230",
  null
  
)

export default component.exports